(ns hai.home.desktop.mini-apps.tasks
  "My Tasks mini-app card: the same task data as the full Tasks page, grouped
   into collapsible Now / Next / Later sections. The header's looking glass
   opens the universal bar; the ＋ swaps the card into Add-a-task mode — the
   header retitles and the body becomes the title form ([[hai.tasks.form]]) —
   and the lane it opens at is named beside it, on the pill that sets it
   ([[hai.tasks.add-pill]]); the title links to the full Tasks page. The task
   rows live here since the dashboard is their only home."
  (:require
   [hai.entity.data :as entity-data]
   [hai.mini-apps.data :as mini-apps-data]
   [hai.mini-apps.frame :as mini-apps]
   [hai.tasks.add-pill :as add-pill]
   [hai.tasks.assignee-picker :as assignee-picker]
   [hai.tasks.card :as task-card]
   [hai.tasks.data :as data]
   [hai.tasks.form :as form]
   [hai.tasks.header :as header]
   [hai.tasks.mini-app :as tasks-mini-app]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.web-app.routing :as routing]
   [hai.web-app.universal-bar :as universal-bar]
   [reagent.core :as r]))

;; Links the add/save toasts to the task. Home lists tasks rather than showing
;; one, so the link always has somewhere to go.
(def ^:private task-link
  {:href-fn #(routing/href :tasks/detail {:task/uuid %})
   :target routing/link-target})

(defn- section-view [{:keys [label tasks open? on-toggle]}]
  [mini-apps/section-view
   {:label label :item-count (count tasks) :open? open? :on-toggle on-toggle}
   (when (seq tasks)
     (into [:div.section-tasks]
           (map (fn [task]
                  ^{:key (:task/uuid task)}
                  [task-card/task-row-component task
                   {:hover-actions? true
                    :show-hint? true
                    :task-link task-link
                    :on-open-entity entity-data/open-entity}]))
           tasks))])

(defn panel [{title :mini-app/title}]
  (r/with-let [!open (r/atom #{:now})
               toggle-section (fn [id]
                                (swap! !open (fn [open]
                                               (if (contains? open id)
                                                 (disj open id)
                                                 (conj open id)))))]
    (let [buckets @(<s [::data/buckets])
          loaded? @(<s [::data/loaded?])
          adding? @(<s [::data/composer-open?])
          saving? (= :start @(<s [:fetch/state ::create]))
          default-urgency @(<s [::data/default-urgency])
          collapsed? @(<s [::mini-apps-data/collapsed? :tasks])
          open @!open
          total (reduce + (map count (vals buckets)))]
      (if adding?
        [tasks-mini-app/card
         [header/bar {:title "Add a task"}
          [:button.bar-action-btn
           {:type "button"
            :aria-label "Close"
            :title "Close"
            :on-click #(>e [::data/close-composer])}
           [icons/outlined-close {:size 18}]]]
         [form/task-form {:draft-id data/composer-draft-id
                          :default-urgency default-urgency
                          :saving? saving?
                          :on-save (fn [staged]
                                     (>e [::data/create (assoc staged
                                                               :request-id ::create
                                                               :task-link task-link
                                                               :success-fx [[:dispatch [::data/close-composer]]])])
                                     (swap! !open conj (data/staged-bucket staged)))
                          :on-cancel #(>e [::data/close-composer])
                          :on-close #(>e [::data/close-composer])
                          :show-hint? true
                          :render-assignee-picker
                          (fn [{:keys [on-pick trigger]}]
                            [assignee-picker/component
                             {:editable? true
                              :on-pick on-pick
                              :label "Assign"
                              :trigger trigger}])}]]
        [tasks-mini-app/card {:class (when collapsed? "collapsed")}
         [header/bar
          {:title title
           :href (routing/href :tasks/view)
           :target routing/link-target}
          [:button.bar-action-btn
           {:type "button"
            :aria-label "Search tasks"
            :title "Search tasks"
            :on-click #(>e [::universal-bar/open])}
           [icons/outlined-search {:size 18}]]
          [add-pill/component
           {:on-add (fn []
                      (>e [::mini-apps-data/expand :tasks])
                      (>e [::data/open-composer (form/from-task nil default-urgency)]))}]
          [mini-apps/collapse-toggle
           {:collapsed? collapsed?
            :label      "tasks"
            :class      "bar-action-btn"
            :on-toggle  #(>e [::mini-apps-data/toggle-collapsed :tasks])}]]
         (when-not collapsed?
           (cond
             (not loaded?) nil
             (zero? total) [:div.app-placeholder "Nothing yet — add your first task above."]
             :else
             (into [:div.task-sections]
                   (map (fn [{:keys [id label]}]
                          ^{:key id}
                          [section-view {:label label
                                         :tasks (get buckets id)
                                         :open? (contains? open id)
                                         :on-toggle #(toggle-section id)}]))
                   data/bucket-tabs)))]))))
